import api from 'lib/api'
import type { FoundPet, Status } from 'types/found-pet'

type FoundPetInput = {
  number: string
  name: string
  email?: string
  phone: string
  hasAlternateContact: boolean
  alternateName?: string
  alternatePhone?: string
  alternateEmail?: string
  pickupInstructions: string
}

export function create(data: FoundPetInput) {
  return api
    .post<{ data: FoundPet }>(`/api/v2/found-pets`, { data })
    .then(({ data }) => data.data)
}

export function fetchOneByToken(token: string) {
  return api
    .get<{ data: FoundPet }>(`/api/v2/found-pets/token/${token}`)
    .then(({ data }) => data.data)
}

export function updateStatusByToken(data: { token: string; status: Status }) {
  const { token, status } = data

  return api
    .patch<{ data: FoundPet }>(`/api/v2/found-pets/token/${token}`, {
      data: { status },
    })
    .then(({ data }) => data.data)
}
